import { render, staticRenderFns } from "./component1.vue?vue&type=template&id=35bcdace&scoped=true&"
import script from "./component1.vue?vue&type=script&lang=js&"
export * from "./component1.vue?vue&type=script&lang=js&"
import style0 from "./component1.vue?vue&type=style&index=0&id=35bcdace&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35bcdace",
  null
  
)

export default component.exports